import { render } from "./PopMenu.vue?vue&type=template&id=781538d2&scoped=true"
import script from "./PopMenu.vue?vue&type=script&lang=js"
export * from "./PopMenu.vue?vue&type=script&lang=js"

import "./PopMenu.vue?vue&type=style&index=0&id=781538d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-781538d2"

export default script